import {
  ResendCodeButton,
  ValidateCodeInput,
} from '@starsoft/common/components';
import styles from '../styles.module.scss';

export default function UserPhoneNumberFormVerifySkeleton() {
  return (
    <div className={styles.container}>
      <ValidateCodeInput setValue={() => {}} isLoading />
      <ResendCodeButton onClick={() => {}} isSkeleton />
    </div>
  );
}
